import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { Field, Spinner } from "@/components/Field";
import { AuthShell } from "./AuthShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) {
      setMsg(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Password dimenticata" subtitle="Inserisci la tua e-mail.">
      {msg ? (
        <p data-testid="forgot-message" className="text-[15px] text-slate-700 bg-slate-50 border rounded-md p-3">{msg}</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="E-mail"><Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 text-base" /></Field>
          <Button data-testid="forgot-submit-button" type="submit" disabled={busy} className="w-full h-12 text-base">{busy ? <Spinner /> : "Invia"}</Button>
        </form>
      )}
      <Link data-testid="back-to-login-link" to="/login" className="block text-center text-sm font-semibold text-primary mt-4">Torna all'accesso</Link>
    </AuthShell>
  );
}
